

exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/credit/index');

var _credit = require('xo-models/src/credit');

var _inventory = require('xo-models/src/inventory');

var _ppcRoute = require('./ppcRoute');

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
    path: 'landing',
    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },
    auth: false,
    resolve: {

        action: function action() {
            var models = {};
            var isPayPalCredit = void 0;

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                auth: _auth.$AuthModel.instance(),
                checkoutPayeeModel: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                flowEligibility: _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');

                if (isPayPalCredit) {
                    return _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*|Trmt_xo_de_ppc_cape_cyco_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_merchant_country_override', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_merchant_country_override_.*', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0],
                            merchantOverride = _ref[1];
                        return {
                            ppcEZPRes: ppcEZPRes,
                            merchantOverride: merchantOverride
                        };
                    });
                } else {
                    return {};
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes,
                    merchantOverride = _ref2.merchantOverride;

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var previousMerchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var buyerCountry = _squid.$locale.country;
                var prevBuyerCountry = _squid.$locale.country;
                var prevBuyerLanguage = _squid.$locale.lang;

                var redirectToCapeCyco = merchantCountry === 'GB';
                var shouldOverrideLocale =
                // Only do this for PPC 2nd button
                isPayPalCredit && !models.auth.loggedIn();

                // Override buyer country to match merchant country for PPC 2nd button
                // https://engineering.paypalcorp.com/confluence/display/MICA/Locale+Issues+on+2nd+Button
                if (shouldOverrideLocale) {

                    if (merchantOverride) {
                        _logger.$logger.info('landing_overriding_merchant_country');
                        merchantCountry = 'GB';
                    }

                    if (
                    // Check that the merchant country is supported
                    merchantCountry && _squid.$config.supportedCountries[merchantCountry] && _squid.$config.creditEligibleCountries.indexOf(merchantCountry) !== -1) {
                        buyerCountry = merchantCountry;
                    } else if (
                    // Check that the buyer country is supported - no need to override if so
                    _squid.$config.supportedCountries[buyerCountry] && _squid.$config.creditEligibleCountries.indexOf(buyerCountry) !== -1) {
                        _logger.$logger.info('landing_overriding_locale_unsupported_merchant', {
                            buyerCountry: buyerCountry,
                            merchantCountry: merchantCountry
                        });
                    } else {
                        // Fallback to US because no supported country can be determined
                        _logger.$logger.warn('landing_overriding_locale_fallback', {
                            buyerCountry: prevBuyerCountry,
                            buyerLanguage: prevBuyerLanguage,
                            merchantCountry: merchantCountry
                        });
                        buyerCountry = 'US';
                    }

                    var supportedLanguages = _squid.$config.supportedCountries[buyerCountry];
                    var lang = void 0;

                    // If the buyer's language exists in the merchant's country, use that, otherwise use default
                    if (supportedLanguages.indexOf(prevBuyerLanguage) !== -1) {
                        lang = prevBuyerLanguage;
                    } else {
                        lang = supportedLanguages[0];
                    }

                    _logger.$logger.info('landing_overriding_locale_success', {
                        prevBuyerCountry: prevBuyerCountry,
                        prevBuyerLanguage: prevBuyerLanguage,
                        newBuyerCountry: buyerCountry,
                        newBuyerLanguage: lang,
                        merchantCountry: merchantCountry,
                        previousMerchantCountry: previousMerchantCountry
                    });

                    // Calling .change here instead of .chooseCountry because we don't want to store the
                    // locale - we want to persist the locale through to the login page, where the locale
                    // can be chosen after the user logs in
                    if (merchantCountry) {
                        _squid.$locale.change(merchantCountry, lang);
                    }
                }

                return {
                    ppcEZPRes: ppcEZPRes, redirectToCapeCyco: redirectToCapeCyco
                };
            }).then(function (_ref3) {
                var ppcEZPRes = _ref3.ppcEZPRes,
                    redirectToCapeCyco = _ref3.redirectToCapeCyco;

                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;

                _logger.$logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = (0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');
                    var isVenmoOneTouch = models.auth.get('tenant') === 'VENMO' && models.auth.get('logged_in');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        _logger.$logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    if (isPayPalCredit) {
                        var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;

                        _logger.$logger.info('checkout_fpti', {
                            'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_ezp'
                        });

                        var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var offers = new _index2.$CreditInstallmentOptionsModel({
                            id: _angular.$rootScope.token,
                            payee: models.checkoutPayeeModel,
                            checkoutCart: models.checkoutCart,
                            checkoutAppData: models.checkoutAppData,
                            isMemberCredit: true
                        });
                        var isInstallmentEligible = models.flowEligibility && models.flowEligibility.installment;

                        return offers.save({
                            cache: true,
                            success: function success(result) {
                                var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                                var installmentOfferDetails = offers.getInstallmentOffers();

                                installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                                if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                                    _logger.$logger.info('xo_landing_ppc_conversion_info_present');
                                    creditDataModel.setCartAmountAndCurrency({
                                        cart_amount: result.conversion_info.converted_transaction_amount.value,
                                        cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                                    });
                                }
                                // Unified login treatment + create account flow (user not logged in)
                                var isUserLoggedIn = models.auth.loggedIn();

                                var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                                var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                    return item.financingCode;
                                }) : [];
                                var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                    return threeMonthFinancingCodeArray.includes(value);
                                }).length > 0);
                                var showCYCOInCAPE = Boolean(ppcEZPTreatment) || redirectToCapeCyco;

                                return (0, _ppcRoute.getPPCRoute)(_logger.$logger, {
                                    showCYCOInCAPE: showCYCOInCAPE,
                                    hasInstallmentOptions: hasInstallmentOptions,
                                    hasThreeMonthInstallment: hasThreeMonthInstallment,
                                    isCapeReturnKey: isCapeReturnKey,
                                    isInstallmentEligible: isInstallmentEligible,
                                    merchantCountry: merchantCountry,
                                    isUserLoggedIn: isUserLoggedIn
                                });
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    if (isVenmoOneTouch) {

                        return 'checkout.venmoAuth';
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _inventory.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Class;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$elmo;

_squid.$util;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$FlowEligibilityModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentOptionsModel;

_credit.$CreditDataModel;

_inventory.$InventoryModel;

_ppcRoute.getPPCRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 0